module.exports = __webpack_public_path__ + "media/images/emblems/Oppligen-coat_of_arms-93262c0c040c3ba62a1692e6a1ef105c.svg";